import React, { ChangeEvent, useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { observable, makeAutoObservable } from 'mobx';

class FormState {
    @observable textareaValue = '';

    constructor(readonly props: CommentBetFormPropsType) {
        this.textareaValue = this.props.data.comment ?? '';
        makeAutoObservable(this);
    }

    onChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        this.textareaValue = event.target.value;
    };

    onBlurHandler = (): void => {
        this.onSubmit();
    };

    onSubmit = (): void => {
        this.props.onSubmit(this.props.data.id, this.textareaValue);
    };
}

type CommentBetFormPropsType = {
    onSubmit: (legId: string, comment: string) => void;
    data: { id: string; comment: string | null }; //betItem
};

export const CommentBetForm = observer('CommentBetForm', (props: CommentBetFormPropsType) => {
    const [state] = useState(() => new FormState(props));

    return (
        <div className='comment-bet-form'>
            <textarea
                value={state.textareaValue}
                placeholder='Bet notes'
                onChange={state.onChangeHandler}
                onBlur={state.onBlurHandler}
            />
        </div>
    );
});
